// import { useCrudOperation } from "@/composables";
// const { update } = useCrudOperation();

export default {
  SET_COMPANY_INSIGHTS(state, companyInsights) {
    state.companyInsights = companyInsights;
  },
  SET_COMPANY_PROFILE(state, data) {
    state.companyProfile = data;
  },
  SET_CANDIDATES_COMP(state, data) {
    state.candidatesComp = {
      items: data.data,
      totalItems: data.count,
    };
  },

  SET_JOB_CANDIDATES_LIST(state, data) {
    state.jobCandidatesLists = {
      items: data.data,
      totalItems: data.count,
    };
  },

  SET_CANDIDATES_JOBS_LIST(state, data) {
    state.candidatesJobList = {
      items: data.data,
      totalItems: data.count,
    };
  },
};
